// extracted by mini-css-extract-plugin
module.exports = {"layout_list_container":"ViewTabs_layout_list_container__1HnRH","layout_button":"ViewTabs_layout_button__21TQY","layout_button_active":"ViewTabs_layout_button_active__1hyQf"};